import { BoardContainer } from './BoardContainer';
import { Ball } from "./Ball";
import { BoardManager } from "./BoardManager";
import { GameVars } from "../../GameVars";

export class BallsContainer extends Phaser.GameObjects.Container {

    public id: number;
    public balls: Ball[];
    public img: Phaser.GameObjects.Image;

    private ballsGroup: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene, id: number, x: number, y: number, ballsGroup: Phaser.GameObjects.Container) {
        
        super(scene);

        this.id = id;

        this.x = x;
        this.y = y;

        this.ballsGroup = ballsGroup;
        this.balls = [];

        this.img = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "balls_container");
        this.img.setOrigin(.5, .86);
        this.img.setInteractive();
        this.img.on("pointerdown", this.onDown, this);
        this.add(this.img);
    }

    public createBall(id: number, scale: number): void {

        const ball = new Ball(this.scene, id, this);
        ball.setScale(scale);
        ball.x = this.x;
        ball.y = this.y - Ball.BALL_RADIUS * ball.scaleX * 2 * 1.05 * (this.balls.length);
        this.ballsGroup.add(ball);
        this.balls.unshift(ball);
    }

    public addBall(ball: Ball): void {

        this.ballsGroup.bringToTop(ball);
        
        let x = this.x;
        let y1 = this.y - Ball.BALL_RADIUS * ball.scaleX * 2 * 1.05 * 4.8;
        let y2 = this.y - Ball.BALL_RADIUS * ball.scaleX * 2 * 1.05 * (this.balls.length);

        this.scene.tweens.add({
            targets: ball,
            y: y1,
            x: x,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100,
            onComplete: () => {
                this.scene.tweens.add({
                    targets: ball,
                    y: y2,
                    ease: Phaser.Math.Easing.Bounce.Out,
                    duration: 200
                });
            },
            onCompleteScope: this
        });

        this.balls.unshift(ball);

        ball.ballsContainer = this;
        ball.canMove = false;
    }

    public getBall(): Ball {

        return this.balls.shift();
    }

    public extractBall(): void {

        this.balls[0].moving = true;
        this.balls[0].extract();
    }

    public restituteBall(): void {

        this.balls[0].restitute();
    }

    private onDown(): void {

        if (GameVars.paused) {
            return;
        }

        BoardManager.onBallsContainerSelected(this.id);
    }
}
